// const group = {
//   FACHHANDEL: 1,
//   WERBE: 2,
//   PRESSE: 3
// }

import shop from "shop/shop"

import { observable } from "mobx"
import settingStore from "stores/settingStore";
import SessionModelBase from "sdk/SessionModel";

export default class SessionModel extends SessionModelBase {
  
  @observable customer = false
  
  constructor( data, shop ) {
    super( data , shop )
    Object.assign( this, data )
    console.log( "SessionModel MODE" )
    try {
      shop.config.MIN_ORDER_VALUE = Number( this.value.extras.minorder )
    } catch (err) {
      console.log( `Customer doesn't provide minorder: ${err}` )
    }
    shop.events.login.dispatch( this )
    
    const mode = settingStore.get( "orderMode" )
    // SET SHOPPING MODE IF WE HAVE ANY
    if ( mode ) {
      console.log( "SETTING ORDER MODE", { mode } )
      if ( mode === "MODE_PREORDER" ) {
        shop.cart.setExtra( "preorder", true )
      } else {
        shop.cart.setExtra( "preorder", false )
      }
    }
  }
  

}



// WEBPACK FOOTER //
// ./src/theme/moderntimes/shop/SessionModel.js